import { queryClient } from 'App';

import { appointmentQueryKeys } from 'lib/constants/constants';

export default async (data) => {
  const { patient } = data;

  queryClient.setQueryData(['patient', patient?.id], (oldData) => {
    if (!oldData) return;
    return {
      ...oldData,
      patient: { ...(oldData?.patient || {}), ...patient }
    };
  });

  //we need to update the patient in all the appointments
  const allSingleAppointmentQueries = queryClient.getQueryCache().findAll(['appointmentv2']);
  for (const query of allSingleAppointmentQueries) {
    queryClient.setQueryData(query.queryKey, (oldData) => {
      if (oldData && oldData?.appointment?.patient?.id === patient?.id) {
        return {
          ...oldData,
          appointment: {
            ...oldData?.appointment,
            patient: { ...oldData?.appointment?.patient, ...patient }
          }
        };
      }
      return oldData;
    });
  }

  appointmentQueryKeys.forEach((key) => {
    queryClient.invalidateQueries({
      queryKey: [key],
      exact: false
    });
  });
};
